import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      img: 'path-to-image-1.jpg',
      name: 'Juan Pérez',
      role: 'Vendedor Profesional',
      text: 'MegaLoto ha transformado mi forma de vender. La plataforma es fácil de usar y las comisiones son muy atractivas.',
    },
    {
      img: 'path-to-image-2.jpg',
      name: 'María Gómez',
      role: 'Experta en Marketing',
      text: 'La oportunidad de ganar dinero con MegaLoto mientras ayudo a otros es increíble. ¡Definitivamente lo recomiendo!',
    },
    {
      img: 'path-to-image-3.jpg',
      name: 'Carlos Rodríguez',
      role: 'Emprendedor',
      text: 'El sistema de referidos de MegaLoto me ha permitido generar ingresos pasivos. ¡Es lo mejor de la industria!',
    }
  ];

  return (
    <section className="testimonials">
      <h2>Lo que dicen nuestros vendedores</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            {/* <img src={testimonial.img} alt={`${testimonial.name}`} className="testimonial-img" /> */}
            <h3 className="testimonial-name">{testimonial.name}</h3>
            <p className="testimonial-role">{testimonial.role}</p>
            <p className="testimonial-text">{testimonial.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
